// reducers/casteReducer.js
export const casteReducer = (
  state = { castes: [], pending: [], rejected: [] },
  action,
) => {
  switch (action.type) {
    case "ALL_CASTES_REQUEST":
    case "PENDING_CASTES_REQUEST":
    case "CREATE_CASTE_REQUEST":
    case "UPDATE_CASTE_REQUEST":
    case "DELETE_CASTE_REQUEST":
      return { ...state, loading: true };

    case "ALL_CASTES_SUCCESS":
      return { ...state, loading: false, castes: action.payload || [] };

    case "PENDING_CASTES_SUCCESS":
      return { ...state, loading: false, pending: action.payload || [] };

    case "REJECTED_CASTES_SUCCESS":
      return { ...state, rejected: action.payload || [] };

    case "CREATE_CASTE_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        castes: [...state.castes, action.payload],
      };

    // A new value typed on the Add Staff/Student form — goes to "pending".
    case "SUGGEST_CASTE_SUCCESS":
      return { ...state, success: true };

    case "APPROVE_CASTE_SUCCESS":
      return {
        ...state,
        pending: state.pending.filter((d) => d.id !== action.payload.id),
        castes: [...state.castes, action.payload].sort((a, b) =>
          a.name.localeCompare(b.name),
        ),
      };

    case "REJECT_CASTE_SUCCESS":
      return {
        ...state,
        pending: state.pending.filter((d) => d.id !== action.payload.id),
        rejected: [...state.rejected, action.payload],
      };

    case "RESUBMIT_CASTE_SUCCESS":
      return {
        ...state,
        rejected: state.rejected.filter((d) => d.id !== action.payload.id),
        pending: [...state.pending, action.payload],
      };

    case "UPDATE_CASTE_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        castes: state.castes.map((d) =>
          d.id === action.payload.id ? action.payload : d,
        ),
      };

    case "DELETE_CASTE_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        castes: state.castes.filter((d) => d.id !== action.payload),
        pending: state.pending.filter((d) => d.id !== action.payload),
        rejected: state.rejected.filter((d) => d.id !== action.payload),
      };

    case "ALL_CASTES_FAIL":
    case "PENDING_CASTES_FAIL":
    case "REJECTED_CASTES_FAIL":
    case "CREATE_CASTE_FAIL":
    case "SUGGEST_CASTE_FAIL":
    case "APPROVE_CASTE_FAIL":
    case "REJECT_CASTE_FAIL":
    case "RESUBMIT_CASTE_FAIL":
    case "UPDATE_CASTE_FAIL":
    case "DELETE_CASTE_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };

    default:
      return state;
  }
};
